module.exports = __webpack_public_path__ + "static/media/userIcon.e141f9dd.svg";